export default __webpack_public_path__ + "static/media/final_logo.3da6ff18.png";